import { Alert } from '../../../../components/ui/Alert'
import { PlanController } from '../../../../services/controllers/subscription'
import { formatMoney } from '../../../../services/functions'
import { usePlans } from '../../../../store/subscription/usePlans'

import { WarningMessage, ScrollArea } from './styles'

export function SaveRules() {
  const CPlan = PlanController()

  const plans = usePlans((st) => st.data.plans)

  const changedFactorPlans = (plans || []).filter((plan) => plan.factor !== plan.oldFactor)
  const plansWithSizeChanges = (plans || [])
    .map((plan) => ({
      plan,
      changedSizes: (plan.sizes || []).filter((s) => s.value !== s.oldValue),
    }))
    .filter((p) => p.changedSizes.length > 0)
  const hasBlackSizeChanges = plansWithSizeChanges.some(({ plan }) => plan.name === 'Black')

  return (
    <Alert.Root name={CPlan.saveRulesAlertName}>
      <Alert.Content style={{ maxWidth: '820px' }}>
        <ScrollArea>
        {!!changedFactorPlans.length && (
          <>
            <Alert.Title>Alteração da Quantidade de Banhos</Alert.Title>
            <Alert.Description>
              <span>
                Você está prestes a alterar a quantidade de banhos pelos quais o
                valor da assinatura será dividido. Esta ação afetará diretamente o
                valor base do banho de assinatura e, consequentemente, influenciará
                o valor das comissões.
              </span>
              <span>
                <strong>
                  Esta nova configuração não será aplicada retroativamente aos
                  banhos de assinatura que já foram finalizados. No entanto, afetará
                  todos os banhos de assinatura que ainda não foram concluídos até o
                  momento da confirmação.
                </strong>
              </span>
            </Alert.Description>
            <Alert.DescriptionContent.List>
              {changedFactorPlans.map((plan, index) => (
                <li 
                  key={plan.id}
                  style={{ 
                    margin: '4px 0',
                    padding: '8px 12px',
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                    borderRadius: '4px',
                    border: '1px solid #e9ecef'
                  }}
                >
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr auto',
                      alignItems: 'center',
                      gap: '20px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <strong style={{ 
                      color: '#495057',
                      justifySelf: 'start'
                    }}>
                      Plano {plan.name}:
                    </strong>
                    <div style={{ 
                      justifySelf: 'end',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{ 
                        color: '#6c757d',
                        textDecoration: 'line-through'
                      }}>
                        {formatMoney(plan.oldFactor, 2)}
                      </span>
                      <span style={{ color: '#6c757d' }}>→</span>
                      <span style={{ 
                        color: '#fd7e14',
                        fontWeight: 'bold'
                      }}>
                        {formatMoney(plan.factor || 1, 2)}
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </Alert.DescriptionContent.List>
          </>
        )}

        {!!plansWithSizeChanges.length && (
          <>
            <Alert.Title>Alterações nos valores da assinatura</Alert.Title>
            <Alert.Description>
              <span>
                Você está prestes a alterar o valor da assinatura. Esta ação afetará
                diretamente o valor da assinatura e, consequentemente, influenciará
                o valor das comissões.
              </span>
              {hasBlackSizeChanges && (
                <span>
                  <strong>Regra: o plano Black é sempre R$ 20 mais caro que o Ilimitado.</strong>
                </span>
              )}
            </Alert.Description>
            <Alert.DescriptionContent.List>
              {plansWithSizeChanges.flatMap(({ plan, changedSizes }) =>
                changedSizes.map((size, index) => {
                  const oldUpgrade = Array.isArray(size.upgradePrice)
                    ? size.upgradePrice.find((u) => u.price === size.oldValue)
                    : null
                  const newUpgrade = Array.isArray(size.upgradePrice)
                    ? size.upgradePrice.find((u) => u.price === size.value)
                    : null
                  return (
                    <li 
                      key={`${plan.id}-${size.id}`}
                      style={{ 
                        margin: '4px 0',
                        padding: '8px 12px',
                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                        borderRadius: '4px',
                        border: '1px solid #e9ecef'
                      }}
                    >
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr auto',
                          alignItems: 'center',
                          gap: '20px',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <strong style={{ 
                          color: '#495057',
                          justifySelf: 'start'
                        }}>
                          Plano {plan.name} - {size.name}:
                        </strong>
                        <div style={{ 
                          justifySelf: 'end',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <span style={{ 
                            color: '#6c757d',
                            textDecoration: 'line-through'
                          }}>
                            {oldUpgrade
                              ? `R$ ${formatMoney(oldUpgrade.price)}`
                              : `R$ ${formatMoney(size.oldValue)}`}
                          </span>
                          <span style={{ color: '#6c757d' }}>→</span>
                          <span style={{ 
                            color: '#fd7e14',
                            fontWeight: 'bold'
                          }}>
                            {newUpgrade
                              ? `R$ ${formatMoney(newUpgrade.price)}`
                              : `R$ ${formatMoney(size.value)}`}
                          </span>
                        </div>
                      </div>
                    </li>
                  )
                })
              )}
            </Alert.DescriptionContent.List>
          </>
        )}
        </ScrollArea>
        <WarningMessage>
          ⚠️ Tem certeza de que deseja confirmar essa alteração?
        </WarningMessage>
        <Alert.Actions>
          <Alert.Cancel onClick={CPlan.undoRules}>Cancelar</Alert.Cancel>
          <Alert.Confirm onClick={CPlan.saveRules}>
            Sim, Atualizar valores
          </Alert.Confirm>
        </Alert.Actions>
      </Alert.Content>
    </Alert.Root>
  )
}
